import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const updateIgnoreStatus = async (isIgnored, testSuiteResultId) => {
  const userDetail = localStorage.getItem("userDetail");
  if (!userDetail) throw new Error("No user details found in localStorage");


  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateIgnoredStatusForTestSuiteResult&testSuiteResultId=${testSuiteResultId}&isIgnored=${isIgnored}`,
  );

  return response.data;
};

const useUpdateIgnoreStatus = (isIgnored, testSuiteResultId, options) => {
  return useMutation({
    mutationFn: () => updateIgnoreStatus(isIgnored, testSuiteResultId),
    ...options,
  });
};
export default useUpdateIgnoreStatus;
